<template>
  <v-list-item class="justify-center pl-7 py-3" @click="setIsMiniSidebarShown(!isMiniSidebarShown)">
    <template #prepend>
      <div :class="['mr-3', { 'pl-2': isMiniSidebarShown }]">
        <v-icon
          :class="[
            'text-primary',
            {
              'rotate-arrow': isMiniSidebarShown
            }
          ]"
          size="24"
          icon="$chevron-left"
        />
      </div>
    </template>
    <template v-if="!isMiniSidebarShown" #title>
      <div class="text-primary">
        {{ $t('main.collapse_panel') }}
      </div>
    </template>
  </v-list-item>
</template>

<script>
  import { mapActions, mapState } from 'pinia'
  import { useSettingsStore } from '@/store/settings/settings'

  export default {
    name: 'ResizerButton',
    computed: {
      ...mapState(useSettingsStore, ['isMiniSidebarShown'])
    },
    methods: {
      ...mapActions(useSettingsStore, ['setIsMiniSidebarShown'])
    }
  }
</script>

<style lang="scss" scoped>
  .rotate-arrow {
    transform: rotate(-180deg);
  }
</style>
